module.exports = "/assets/data/a16cc4c3e4a80cfcb61070be04079c6f-SR4.data.json";